<div class="cb-input-phone">
    <cb-input #Input [(ngModel)]="value" [placeholder]="placeholder()" [label]="label()" [hint]="hint()" [info]="info()"
        [required]="required() ?? false" [disabled]="disabled()" [icon]="icon()" [copyButton]="copyButton()"
        [error]="error()" [name]="name() ?? ''" (change)="onChange()"
        [leadingDropdownOptions]="prefixOptions"></cb-input>
</div>